/**
 * Atributet e krahasueshme të një kandidati.
 *
 * Aplikimi tashmë mban përvojën dhe aftësitë si tekst të lirë, dhe ai tekst
 * mbetet — është ajo që shkroi vetë personi. Këto fusha nuk e zëvendësojnë atë;
 * ato shtojnë formën e krahasueshme: gjuha me nivel, vitet si numër, angazhimi
 * si kod. Pa to, kërkimi historik nuk ka si të thotë «gjermanisht C1 ✓».
 *
 * Të gjitha janë opsionale. Ajo që lihet bosh quhet «nuk dihet» te krahasimi,
 * jo «jo» — mungesa e të dhënës nuk është provë kundër personit.
 */
import React from 'react';
import { Grid, MenuItem, TextField, Typography } from '@mui/material';
import { LANGUAGES, LANGUAGE_LEVELS, EMPLOYMENT_TYPES, WORKPLACE_TYPES } from '../../config/recruitmentCriteria';

const asList = (v) => String(v || '').split(',').map((x) => x.trim()).filter(Boolean);

export default function CandidateAttributeFields({ value = {}, onChange, dense = false }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const lang = (value.languages || [])[0] || { code: '', level: '' };
  const size = dense ? 'small' : 'medium';

  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12}>
        <Typography variant="caption" color="text.secondary">
          Opsionale. Përdoren kur hapet një pozitë e re, për të parë nëse ky person mund të përputhet.
        </Typography>
      </Grid>
      <Grid item xs={7} sm={4}>
        <TextField select size={size} fullWidth label="Gjuha" value={lang.code || ''}
          onChange={(e) => {
            const code = e.target.value;
            set({ languages: code ? [{ code, level: lang.level || 'B2' }] : [] });
          }}>
          <MenuItem value="">—</MenuItem>
          {LANGUAGES.map((l) => <MenuItem key={l.code} value={l.code}>{l.label}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid item xs={5} sm={2}>
        <TextField select size={size} fullWidth label="Niveli" value={lang.level || ''} disabled={!lang.code}
          onChange={(e) => set({ languages: [{ code: lang.code, level: e.target.value }] })}>
          {LANGUAGE_LEVELS.map((l) => <MenuItem key={l} value={l}>{l}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField size={size} fullWidth type="number" label="Përvoja (vjet)" inputProps={{ min: 0, max: 50 }}
          value={value.experienceYears ?? ''}
          onChange={(e) => set({ experienceYears: e.target.value === '' ? undefined : Number(e.target.value) })} />
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField size={size} fullWidth label="Lokacioni" value={value.location || ''}
          onChange={(e) => set({ location: e.target.value })} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField select size={size} fullWidth label="Angazhimi i kërkuar" value={(value.employmentTypes || [])[0] || ''}
          onChange={(e) => set({ employmentTypes: e.target.value ? [e.target.value] : [] })}>
          <MenuItem value="">—</MenuItem>
          {EMPLOYMENT_TYPES.map((t) => <MenuItem key={t.code} value={t.code}>{t.label}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField select size={size} fullWidth label="Vendi i punës" value={(value.workplaceTypes || [])[0] || ''}
          onChange={(e) => set({ workplaceTypes: e.target.value ? [e.target.value] : [] })}>
          <MenuItem value="">—</MenuItem>
          {WORKPLACE_TYPES.map((t) => <MenuItem key={t.code} value={t.code}>{t.label}</MenuItem>)}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField size={size} fullWidth label="Aftësi për krahasim" placeholder="crm, excel, zendesk"
          helperText="Të ndara me presje — shtesë ndaj përshkrimit me fjalë më lart"
          value={(value.skills || []).join(', ')}
          onChange={(e) => set({ skills: asList(e.target.value) })} />
      </Grid>
    </Grid>
  );
}
